//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function () {
	var App = angular.module('pphhApp');
	App.service("updateCodeTableService", ["$http", "$q", function ($http, $q) {
		this.uploadFile = function(file,options) {
			var formData = new FormData();
			formData.append("file", file);
			formData.append("options", options);
			var request = {
					method: "POST",
					url: _contextPath + "/updateCodeTable/importAccessCodes",
					data: formData,
					transformRequest: angular.identity
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			request.headers["Content-type"] = undefined;
	
			var deferred = $q.defer();
			$http(request)
			.then(function(res) {
				deferred.resolve(res);
			}, function(msg, code) {
				deferred.reject(msg);
			});
			return deferred.promise;
		};
	
		this.listMasterCodes = function() {
	
			var deferred = $q.defer();
	
			$http.get(_contextPath + "/updateCodeTable/listAccessCodes")
			.then(function(res) {
				deferred.resolve(res.data);
			});
			return deferred.promise;
		};
	}]);
})();

